<template>
  <div class="is-relative">
    <OperationsCheckboxes :positionId="position_id" :companyId="company_id" />
    <DataTable
      :is_createable="false"
      :show_delete="false"
      title="Position Offers"
      @thFilter="thFilter"
      @generate_offers="generateOffers"
      @edit_click="editClick"
      @cv="clickedCV"
      @cv_other="clickedCvOther"
      @internal_notes="clickedInternalNotes"
      @reject_offer="rejectOffer"
      @send_whatsapp="sendWhatsapp"
      @related_positions="relatedPositions"
      @text_search_results="textSearchResults"
      @position_modal_hover="positionModalHover"
      @position_modal_leave="positionModalLeave"
      @conected_positions="showConnectedPositionManager"
      @expose_offer="exposeOffer"
      @send_history="sendHistory"
      @score="score"
      :unique_buttons="unique_buttons"
      :filters="filters"
      :sorters="sorters"
      :fields="fields"
      :counters="counters"
      :response="data"
      :operations="operations"
      :working_th_searches="working_th_searches"
      :pageTitleAdditionData="{ showGhanaFlag: true, company_self_row: true, sent_applicants: true }"
    />
  </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex'
import OffersHelper from '@/custom/classes/offers_helper.js'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
import OperationsCheckboxes from '@/components/OperationsCheckboxes.vue'
import cvOtherMixin from '@/mixins/cvOtherMixin.js'

export default {
  name: 'position-offers',
  mixins: [cvOtherMixin],
  data () {
    return {
      offers_helper: new OffersHelper(),
      filters_helper: new FiltersHelper(),
      fields: [
        {
          name: 'full_name',
          component: 'LinkEntity',
          component_data_path: 'applicant'
        },
        {
          name: 'applicant_message',
          component: 'Message',
          component_data_path: 'applicant',
          additional_data: {
            endpoint: '/users/',
            headers: 'admin_headers',
            resource_type: 'Applicant',
            show_attribute_form: true
          }
        },
        {
          name: 'status',
          value: 'status.name',
          component: 'OfferStatus'
        },
        {
          name: 'offer_message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/offers/',
            headers: 'admin_headers',
            resource_type: 'Offer'
          }
        },
        {
          name: 'distance',
          value: 'distance',
          component: 'OfferDistance'
        },
        {
          name: 'position_message',
          value: 'position.message'
        },
        {
          name: 'last_login',
          value: 'applicant.last_login',
          is_time: true
        },
        {
          name: 'active_at',
          value: 'applicant.active_at',
          is_time: true
        },
        {
          name: 'filters_message',
          value: 'filters_message'
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        },
        {
          name: 'sent_at',
          value: 'sent_at',
          is_time: true
        },
        {
          name: 'applicant_id',
          value: 'applicant.resource_id'
        },
        {
          name: 'applicant_status',
          value: 'applicant.status'
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'score',
          value: 'score'
        },
        {
          name: 'score_info',
          value: 'score_info'
        }
      ],
      filters: [
        {
          type: 'multi_term_input',
          designator: 'applicant_text',
          class: this.$route.query.animation == 'TRUE' ? 'pulse_animation_2' : '',
          placeholder: 'Search by applicant text'
        },
        {
          type: 'input',
          designator: 'applicant_name'
        },
        {
          type: 'input',
          designator: 'min_experience',
          customPlaceholder: 'Min experience',
          class: 'width-170'
        },
        {
          type: 'input',
          designator: 'max_experience',
          customPlaceholder: 'Max experience',
          class: 'width-170'
        },
        {
          type: 'checkbox',
          designator: 'filter_by_related',
          title: 'Related offers',
          rtl: true,
          custom_addition_to_query: { statuses: undefined, filter_by_connected: undefined }
        },
        {
          type: 'checkbox',
          designator: 'filter_by_connected',
          title: 'Connected offers',
          rtl: true,
          custom_addition_to_query: { statuses: undefined, filter_by_related: undefined }
        },
        {
          type: 'checkbox',
          designator: 'filter_by_active',
          title: 'Active applicants',
          rtl: true
        },
        {
          type: 'modal',
          designator: 'applicant_status',
          options: [
            { text: 'completed', value: 'completed' },
            { text: 'vetted', value: 'vetted' },
            { text: 'unvetted', value: 'unvetted' },
            { text: 'irrelevant', value: 'irrelevant' }
          ]
        },
        {
          type: 'modal',
          designator: 'one_position_job_titles',
          options: this.singleDropdownJobTitles,
          splitter: '|'
        },
        {
          type: 'modal',
          designator: 'skills_exact',
          label: 'skills exact',
          options: this.dropdownSkills,
          grouped: 'category',
          searchable: true
        },
        {
          type: 'modal',
          designator: 'skills',
          options: this.dropdownSkills,
          searchable: true
        },
        {
          type: 'modal',
          designator: 'statuses',
          options: this.getFiltersOptions
        },
        {
          type: 'modal',
          designator: 'certification_range',
          options: [],
          subType: 'min-max'
        },
        {
          type: 'single',
          designator: 'owner',
          options: this.dropdownAdmins
        },
        {
          type: 'range',
          designator: 'max_distance'
        },
        {
          type: 'range',
          designator: 'min_salary_expectations',
          minValue: '5000',
          maxValue: '100000'
        }
      ],
      sorters: [
        {
          designator: '',
          value: ''
        },
        {
          designator: 'active_at',
          value: '-active_at',
          custom_sort: true
        },
        {
          designator: 'sent_at',
          value: '-sent_at'
        },
        {
          designator: 'updated_at',
          value: '-updated_at'
        },
        {
          designator: '+distance',
          value: 'distance'
        },

        {
          designator: 'score',
          value: '-score'
        }
      ],
      data: [],
      counters: [],
      operations: [
        { component: 'Preview', additional_data: { resource_type: 'Offer' } },
        { name: 'CV' },
        { name: 'cv_other', title: 'CV Other' },
        { name: 'reject_offer', icon: '/black_x.png' },
        { name: 'send_whatsapp', title: 'Send Offer WA' },
        { name: 'internal_notes', icon: '/note.png' },
        { name: 'related_positions', icon: '/magic_wand.png' },
        { component: 'OfferWhatsAppLink' },
        { name: 'position_modal', icon: '/applicant_modal.png' },
        {
          component: 'BoosterButton',
          additional_data: { resource_type: 'Offer' }
        },
        {
          component: 'ButtonEvaluate',
          additional_data: { resource_type: 'Offer' }
        },
        { component: 'OperationScore' },
        { name: 'expose_offer', title: 'expose' },
        { name: 'send_history', title: 'שליחות' }
      ],
      unique_buttons: [
        { name: 'generate_offers', display_text: 'Generate Offers' },
        { name: 'score', display_text: 'Score' },
        { name: 'conected_positions', display_text: 'Conected Positions' },
        { component: 'ScoreThisPage', payload: { d: this.getQueryParams, c: this.getCounters, type: 'Position', id: this.$route.query.position_id } }
      ],
      position_id: this.$route.query.position_id,
      company_id: this.$route.query.company_id,
      th_filters: [],
      working_th_searches: ['full_name', 'company_name', 'position_title', 'owner']
    }
  },
  created: function () {
    this.init()
    this.fetchAll()
    this.fetchAllSkills()
    this.watchTreeShaking(this.singleDropdownJobTitles, 'one_position_job_titles')
    this.watchTreeShaking(this.getFiltersOptions, 'statuses')
  },
  computed: {
    ...mapGetters('modals', ['findModal']),
    ...mapGetters('admins', ['dropdownAdmins']),
    ...mapGetters('skills', ['dropdownSkills']),
    ...mapGetters('jobTitles', ['singleDropdownJobTitles']),
    ...mapGetters('offerStatuses', ['getFiltersOptions', 'getAdvancedStatuses', 'getStarStatuses'])
  },
  watch: {
    dropdownAdmins (newValue) {
      this.watchTreeShaking(newValue, 'owner')
    },
    singleDropdownJobTitles (newValue) {
      this.watchTreeShaking(newValue, 'one_position_job_titles')
    },
    dropdownSkills (newValue) {
      this.watchTreeShaking(newValue, 'skills')
      this.watchTreeShaking(newValue, 'skills_exact')
    },
    getFiltersOptions (newValue) {
      this.watchTreeShaking(newValue, 'statuses')
    }
  },
  methods: {
    init () {
      this.getOffers()
    },
    sendWhatsapp (data) {
      this.create({
        designator: 'whatsapp-conversation-modal',
        component_name: 'ModalWhatsappMessager',
        modal_title: 'Conversation',
        props: {
          applicant: data.applicant,
          offer: data
        }
      })
    },
    watchTreeShaking (newValue, designator) {
      this.filters.forEach(filter => {
        if (filter.designator == designator) {
          filter.options = newValue
        }
      })
    },
    async getOffers () {
      this.data = []
      if (this.$route.query.applicant_text) {
        this.operations.push({ name: 'text_search_results', icon: '/applicant_text_search.png' })
        this.fields.splice(4, 0, {
          name: 'Applicant Text',
          value: 'applicant.resource_id',
          component: 'TextSearchResultContainer',
          css_classes: {
            'max-width-450': () => true
          }
        })
      }
      const public_name = await this.$network_utils.getResourceText({ current_type: 'Company', current_resource_id: this.company_id, designator: 'public_hidden_name' })
      const [positionLocation] = await this.$network_utils.getResourceLocations({ current_type: 'Position', current_resource_id: this.position_id })
      if (!positionLocation) {
        alert('נא להזין למשרה את המיקום שלה ולרענן את העמוד')
        return
      }
      const query = this.getQueryParams()
      this.$network_utils.getResourceOffers(query).then(response => {
        let data = []
        for (let i = 0; i < response.length; i++) {
          let offer = response[i]
          const { applicant: { first_name, last_name } } = offer
          offer.applicant_name = `${first_name} ${last_name}`
          offer.position.location = positionLocation.description
          offer.position.company.is_discrete = true
          offer.position.company.public_name = public_name.content
          data.push(offer)
        }
        this.data = data
        this.getCounters().then(response => {
          this.counters.push({
            name: 'result-counter',
            label: 'Result counter',
            value: response
          })
        })
      })
    },
    getCounters () {
      const query = this.getQueryParams()
      return this.$network_utils
        .getResourceOffers({
          ...query,
          count_only: true,
          per: undefined,
          page: undefined
        })
    },
    async showConnectedPositionManager () {
      const positionData = await this.$network_utils.getPosition({ id: this.position_id })
      this.create({
        designator: 'connected-position-manager-modal',
        component_name: 'ConnectedPositionManager',
        position: positionData,
        modal_title: positionData.title + ' - Connected Position Manager',
        is_center_modal: true,
        modal_width: 1400
      })
    },
    getQueryParams () {
      const sortCheck = this.$route.query.custom_sort ? this.$route.query.custom_sort : '-applicant_submitted_at'
      return {
        resource_type: 'Position',
        resource_id: this.position_id,
        ...this.filters_helper.getServerCallFilters(this.filters),
        sort: this.$route.query.sort || sortCheck,
        custom_sort: this.$route.query.custom_sort,
        per: 100,
        page: this.$route.query.page || 1,
        similar_positions: this.$route.query.filter_by_related ? this.position_id : undefined,
        connected_positions: this.$route.query.filter_by_connected ? this.position_id : undefined,
        activeness: this.$route.query.filter_by_active ? '50' : undefined,
        ...(this.$route.query.applicant_text && { applicant_text: encodeURIComponent(this.$route.query.applicant_text) }),
        applicant_tag: this.$route.query.applicant_tag,
        ...this.th_filters
      }
    },
    getQuestionWithSortedOptions (question) {
      question.options.sort((a, b) => b.option_order - a.option_order)
      return question
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getOffers()
    },
    async score () {
      const answer = confirm('are you sure to score 1 hour?')
      if (answer) {
        await this.$network_utils.postEvent({
          event: 'resource_score',
          current_type: 'Position',
          current_resource_id: this.position_id
        })
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      }
    },
    relatedPositions (data) {
      this.create({
        designator: 'related-positions-modal',
        component_name: 'RelatedPositions',
        position: data.position,
        applicant: data.applicant,
        modal_title: data.position.title + ' - ' + data.position.company.name + ' - Related Positions '
      })
    },
    rejectOffer (data) {
      this.create({
        designator: 'reject-offer-modal-reason',
        component_name: 'MessageForm',
        resource_data: data,
        is_submitable: true,
        triggerBtn: true,
        additional_data: { endpoint: '/offers/', headers: 'admin_headers', resource_type: 'Offer' },
        modal_title: 'Reason for reject offer',
        props: {
          label: 'נא לפרט סיבה',
          onSubmit: id => {
            this.offers_helper.rejectOffer(data)
            this.removeModalById(id)
          }
        }
      })
    },
    textSearchResults (data) {
      this.$network_utils.getResourceTexts({
        current_type: 'Applicant',
        current_resource_id: data.applicant.resource_id
      }).then(response => {
        this.create({
          designator: `text-search-result-modal-${data.id}`,
          component_name: 'TextSearchResult',
          modal_title: 'Applicant Text Search Result',
          payload: data,
          props: {
            searchKeyword: this.$route.query.applicant_text,
            tags: data.applicant.tags || '',
            message: data.applicant.message || '',
            text: response,
            applicant: data.applicant
          }
        })
      })
    },
    starStatuses () {
      this.$router.push({ name: this.$route.name, query: { ...this.$route.query, statuses: this.getStarStatuses } })
    },
    createdStat (text) {
      this.$network_utils.postStat({
        designator: 'position_search_method',
        priority: 5,
        resource_type: 'Position',
        resource_id: this.position_id,
        owner: this.$utils.getOwner().name,
        title: `Position search: ${text}`,
        content: text
      })
    },
    clickedCV (data) {
      this.create({
        designator: 'send-cv-mode-selection-modal',
        component_name: 'SendCvModeSelectionModal',
        data,
        modal_title: 'בחירת מצב שליחת קורות חיים',
        modal_width: 600,
        is_center_modal: true
      })
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Offer', resource_id: data.id, modal_title: 'הערות פנימיות' })
    },
    positionModalHover (data) {
      this.create({
        designator: 'position-info-modal',
        component_name: 'ModalPosition',
        modal_width: 1500,
        resource_type: 'Position',
        resource_id: this.position_id,
        modal_open_action: 'no-click',
        override_modal_x: 500,
        modal_title: data.position.title + (data.position.is_discrete ? ' (DISCRETE)' : ''),
        // עותק ולא המשרה עצמה — הוספת הקשר המועמד לא אמורה לשנות את השורה בטבלה.
        // applicant_id מפעיל את פירוט הכישורים מהשיחה בתוך המודל.
        data: { ...data.position, ...this.$utils.applicantModalContext(data.applicant) }
      })
    },
    positionModalLeave () {
      let position_info_modal = this.findModal({ type: 'designator', value: 'position-info-modal' })
      this.remove(position_info_modal)
    },
    generateOffers (data) {
      this.$network_utils.postEvent({ event: 'resource_updated', current_type: 'Position', position_id: this.position_id, current_resource_id: this.position_id, current_company_id: this.company_id, sidekiq_queue: 'high' }).then(() => {
        this.$utils.emit('show_toast', { text: 'נשלח בהצלחה' })
      })
    },
    editClick (data) {
      this.create({ designator: 'position-offers-form-modal', component_name: 'PositionOffersForm', data, position_id: this.$route.query.position_id, company_id: this.$route.query.compny_id, modal_title: 'Edit Offer', position_status: this.$route.query.position_status })
    },
    async exposeOffer (data) {
      // Check if company has active employees before opening the preparation modal
      if (!data.position || !data.position.company || !data.position.company.id) {
        this.$utils.emit('show_toast', { text: 'חסרים פרטי חברה', type: 'error' })
        return
      }

      try {
        const employees = await this.$network_utils.getCompanyEmployees({
          company_id: data.position.company.id
        })

        if (!employees || employees.length === 0) {
          // No active employees - show message and open employee modal first
          this.$utils.emit('show_toast', {
            text: 'לחברה זו אין אנשי קשר פעילים. יש להוסיף איש קשר לפני חשיפת ההצעה.',
            type: 'warning'
          })

          // Open the exposure modal directly so user can add an employee
          this.create({
            designator: 'offer-exposure-modal',
            component_name: 'OfferExposureModal',
            modal_title: 'חשיפת הצעה - הוספת איש קשר',
            modal_width: 900,
            props: {
              offer: data,
              selectedFiles: []
            }
          })
          return
        }

        // Has active employees - proceed with normal flow
        this.create({
          designator: 'offer-exposure-preparation-modal',
          component_name: 'OfferExposurePreparationModal',
          modal_title: 'הכנה לחשיפת הצעה',
          modal_width: 900,
          props: {
            offer: data
          }
        })
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error checking company employees:', error)
        this.$utils.emit('show_toast', { text: 'שגיאה בבדיקת אנשי קשר', type: 'error' })
      }
    },
    sendHistory (data) {
      this.create({
        designator: 'cv_send_history',
        component_name: 'CvSendHistoryModal',
        modal_title: 'היסטוריית שליחות',
        modal_width: 900,
        is_center_modal: true,
        props: { offer: data }
      })
    },
    ...mapMutations('modals', ['create', 'removeModalById', 'remove']),
    ...mapActions('admins', ['fetchAll']),
    ...mapActions('skills', ['fetchAllSkills'])
  },
  components: {
    DataTable,
    OperationsCheckboxes
  }
}
</script>
